import {
  queryOptions,
  useMutation,
  type UseMutationOptions,
} from "@tanstack/react-query";
import { queryClient } from "@config/tanstack/tanstackQuery";
import { backendApiV2 } from "../backendApi";
//
import type {
  SpringHealthEligiblePayload,
  SpringHealthEligibileResp,
  //
  SpringHealthEnrollNewAccountPayload,
  SpringHealthEnrollExistingAccountPayload,
  SpringHealthEnrollResp,
} from "@neuromotion-inc/mightier-ts-sdk";

export const springHealthEligibileQueryOpts = (
  payload: SpringHealthEligiblePayload,
) => {
  return queryOptions({
    queryKey: ["spring-health", "eligibility", payload],
    queryFn: async () => {
      console.log("RUNNING ");
      const resp = await backendApiV2.springHealthCheckEligibility(payload);
      return resp.data;
    },
  });
};

//
//
//

interface CheckSpringEligibilityMutationVars {
  payload: SpringHealthEligiblePayload;
}

type CheckSpringEligibilityMutOpts = Pick<
  UseMutationOptions<
    SpringHealthEligibileResp,
    Error,
    CheckSpringEligibilityMutationVars
  >,
  "onError" | "onSuccess"
>;

export const useCheckSpringEligibilityMutation = (
  opts: CheckSpringEligibilityMutOpts,
) => {
  return useMutation({
    ...opts,
    mutationFn: async (vars: CheckSpringEligibilityMutationVars) => {
      const resp = await backendApiV2.springHealthCheckEligibility(
        vars.payload,
      );
      return resp.data;
    },
    onSuccess: (data, vars, ...rest) => {
      const queryKey = springHealthEligibileQueryOpts(vars.payload).queryKey;
      queryClient.setQueryData(queryKey, data);
      opts.onSuccess?.(data, vars, ...rest);
    },
  });
};

//
//
//

type EnrollmentVars =
  | {
      accountExists: true;
      payload: SpringHealthEnrollExistingAccountPayload;
    }
  | {
      accountExists: false;
      payload: SpringHealthEnrollNewAccountPayload;
    };

type EnrollMutationOpts = UseMutationOptions<
  SpringHealthEnrollResp,
  Error,
  EnrollmentVars
>;

export function useEnrollMutation(
  opts: Pick<EnrollMutationOpts, "onSuccess" | "onError">,
) {
  return useMutation({
    ...opts,
    mutationFn: async (vars: EnrollmentVars) => {
      const { payload } = vars;
      const resp = await backendApiV2.springHealthEnroll(payload);
      return resp.data;
    },
  });
}
